/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import "@babel/polyfill";

import baustein from "baustein";
import analytics from "analytics/analytics";
import userProfiler from "modules/userprofiler";
import browser from "utils/browser";
import alerts from "utils/alerts";
import routes from "routing/routes";
import loadFonts from "utils/load-fonts";
import jinjaToJs from "jinja-to-js";
import { installJinjaFilters } from "modules/jinja-filters";
import { installJinjaGlobals } from "modules/jinja-globals";
import "components/index";
import { initialiseReact } from "react/main.jsx";

loadFonts();

installJinjaFilters(jinjaToJs);
installJinjaGlobals(jinjaToJs);

analytics.init();
userProfiler.init();
browser.init();
alerts.init();
baustein.init();

if (baustein.getInstanceOf("lyst-app")) {
    routes.setup();
}

analytics.pageView();
initialiseReact();
// we expose this as a global so 3rd parties can interact with our analytics
window.lystAnalytics = {
    event: analytics.event.bind(analytics)
};

